import { NoAdsProfileIcon } from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from '../NoAds.styles';
import { Props } from '../NoAds.types';

export const NoAdsProfile: Props = ({ t }) => (
  <S.NoAdsWrapper data-testid="no-ads-profile">
    <NoAdsProfileIcon />
    <S.TextWrapper>
      <Typography variant="h0">{t('NoAds.profile.title')}</Typography>
      <Typography variant="body2">{t('NoAds.profile.subtitle')}</Typography>
    </S.TextWrapper>
  </S.NoAdsWrapper>
);
